'use client';

import { ComponentProps, forwardRef } from 'react';
import NextImage from 'next/image';

import { scene7ImageLoader } from './loader';
import { BLUR_IMAGE_PLACEHOLDER } from './constants';

import { getScene7Url, Scene7Props } from '@cat-ecom/common/utils/scene7Utils';

export type CustomImageProps = ComponentProps<typeof NextImage> &
  Scene7Props & { src: string };

export const Image = forwardRef<HTMLImageElement, CustomImageProps>(
  function Image(
    // Extract scene7 props from Image props
    {
      format,
      fit,
      upscale = true,
      position,
      additionalParams,
      placeholder = BLUR_IMAGE_PLACEHOLDER,
      ...props
    },
    ref
  ) {
    const scene7Props: Scene7Props = {
      width: props.width,
      height: props.height,
      quality: props.quality,
      format,
      fit,
      upscale,
      position,
      additionalParams
    };

    return (
      <NextImage
        ref={ref}
        placeholder={placeholder}
        {...props}
        src={getScene7Url(props.src, scene7Props)}
        loader={scene7ImageLoader}
      />
    );
  }
);
